import React from 'react';
import {
  Box,
  Grid,
  Stack,
} from '@mui/material';
import {
  ChipOption,
  ChipSelectList,
  MultiCountrySelector,
  DebouncedSearchInput,
} from '@marageti/z4-lib';
import { PartnerStatus } from '@marageti/z4-sdk/lib/travel';

export const statusChipOptions: ChipOption[] = [
  { key: 0, label: 'Onboarding', value: PartnerStatus.ONBOARDING },
  { key: 1, label: 'New', value: PartnerStatus.NEW },
  { key: 2, label: 'Active', value: PartnerStatus.ACTIVE },
  { key: 3, label: 'Non-Strategic', value: PartnerStatus.NON_STRATEGIC },
  { key: 4, label: 'Phasing Out', value: PartnerStatus.PHASING_OUT },
  { key: 6, label: 'Inactive', value: PartnerStatus.INACTIVE },
];

type AllPartnersFiltersProps = {
  onChange: (n: string, v: string | string[]) => void;
  primaryCountries: string[],
  searchValue: string;
  selectedStatusChips: string[];
};

const AllPartnersFilters = ({
  onChange,
  primaryCountries,
  searchValue,
  selectedStatusChips,
}: AllPartnersFiltersProps) => (

  <Box>

    <Grid container columnSpacing={2} rowSpacing={2}>
      <Grid item xs={12} md={6} lg={3}>
        <DebouncedSearchInput
          fullWidth
          key="fullText"
          label="Search"
          name="fullText"
          onChange={(v) => onChange('fullText', v)}
          defaultValue={searchValue}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <MultiCountrySelector
          key="destination-select"
          label="Primary Country"
          name="primaryCountries"
          onChange={(e: React.SyntheticEvent, value: string[]) => onChange('primaryCountries', value)}
          value={primaryCountries}
        />
      </Grid>
    </Grid>
    <Stack sx={{ mt: 1, mb: 4 }}>
      <ChipSelectList
        chipOptions={statusChipOptions}
        label="Status"
        onChange={(v: string[]) => onChange('status', v)}
        selectedChips={selectedStatusChips}
      />
    </Stack>
  </Box>
);

export default AllPartnersFilters;
